import './ReferralOptOutDetails.scss'
import React, {Component} from 'react'
import { Button, Modal, Input } from 'react-bootstrap'
import { connectModal, show as showModal } from 'redux-modal'
import cx from 'bem-classnames'
import { isValidEmail } from 'common/util/helper'

import {
  submitReferralOptOut,
  updateValidationAttempted,
  resetReferralOptOut,
  updateCompany,
  updateOfficer,
  updateRefer,
  updateEmail,
  updatePhone,
  updateReasons,
  updateFeedback
} from 'manager/redux/referral_opt_out'


class ReferralOptOut extends Component {
  render() {
    return (
      <Modal show={this.props.show} className="RMBarModal">
        <Modal.Header>
          <Modal.Title>Why do we ask this?</Modal.Title>
          <div onClick={this.props.handleHide} className="RMBarModal__image-close"/>
        </Modal.Header>

        <Modal.Body>
          <div className="text">
            <div>There are many good service providers for clients to choose from and, at Opcity, we encourage clients to shop around to determine that they are receiving the best possible rates and services. So that we can continue to offer quality options to homebuyers, we want to better understand why chosen partners are the best fits for clients.</div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}
const ReferralOptOutModal = connectModal({ name: 'ReferralOptOutModal', destroyOnHide: true })(ReferralOptOut)

class RequiredField extends Component {
  render() {
    return (
      <Modal show={this.props.show}>
        <Modal.Header>
          <Modal.Title>{this.props.fieldName} required</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div>
            {this.props.description}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={this.props.handleHide}>OK</Button>
        </Modal.Footer>
      </Modal>)
  }
}
const RequiredFieldModal = connectModal({ name: 'RequiredFieldModal', destroyOnHide: true })(RequiredField)


const reasonClasses = {
  name: 'ReferralOptOutDetails__reason',
  modifiers: [
    'last',
    'selected',
    'missing',
  ]
}

class ReferralOptOutDetails extends Component {

  constructor(props) {
    super(props)
  }

  componentWillMount() {
    this.props.dispatch(resetReferralOptOut(
      this.props.company,
      this.props.officer,
      this.props.refer,
      this.props.email,
      this.props.phone,
      this.props.reasons,
      this.props.feedback
    ))
  }

  updateRefer(event) {
    if (event) {
      this.props.dispatch(updateRefer(event.target.checked))
    } else {
      this.props.dispatch(updateRefer(!this.props.referralOptOut.refer))
    }
  }

  updateReasons(reason) {
    let reasons = []
    if (!this.props.referralOptOut.reasons) {
      reasons.push(reason)
    } else {
      reasons = this.props.referralOptOut.reasons.slice(0)
      const index = reasons.indexOf(reason)
      if (index !== -1) {
        reasons.splice(index, 1)
      } else {
        reasons.push(reason)
      }
    }
    this.props.dispatch(updateReasons(reasons))
  }

  validate() {
    const validCompany = !!this.props.referralOptOut.company && this.props.referralOptOut.company.trim() !== ''
    const validEmail = !this.props.referralOptOut.refer || isValidEmail(this.props.referralOptOut.email)
    const validReasons = !this.props.hasActiveAssignment || (!!this.props.referralOptOut.reasons && this.props.referralOptOut.reasons.length > 0)
    this.props.dispatch(updateValidationAttempted(validCompany, validEmail, validReasons))

    if (!validCompany) {
      this.props.dispatch(showModal('RequiredFieldModal', {fieldName:this.props.companyLabel + ' name', description:'Please enter a ' + this.props.companyLabel + ' name.'}))
      return false
    }

    if (!validEmail) {
      this.props.dispatch(showModal('RequiredFieldModal', {fieldName:'Email', description:'Please enter a valid email address.'}))
      return false
    }

    if (!validReasons) {
      this.props.dispatch(showModal('RequiredFieldModal', {fieldName:'Reasons', description:'Please select the reason(s) why you chose not to use ' + this.props.assignedCompany + '.'}))
      return false
    }

    const valid = validCompany && validEmail && validReasons

    if (!valid) {
      window.alert("Required fields missing!")
    }
    return valid
  }

  handleSubmit() {
    if (this.validate()) {
      if (this.props.onSubmit) {
        this.props.onSubmit(
          this.props.referralOptOut.company,
          this.props.referralOptOut.officer,
          this.props.referralOptOut.refer,
          this.props.referralOptOut.email,
          this.props.referralOptOut.phone,
          this.props.referralOptOut.reasons,
          this.props.referralOptOut.feedback,
        )
        this.props.handleHide()
      } else {
        this.props.dispatch(submitReferralOptOut(
          this.props.params.hash,
          this.props.type,
          this.props.referralOptOut.company,
          this.props.referralOptOut.officer,
          this.props.referralOptOut.refer,
          this.props.referralOptOut.email,
          this.props.referralOptOut.phone,
          this.props.referralOptOut.reasons,
          this.props.referralOptOut.feedback,
        ))
      }
    }
  }

  render() {

    const renderReason = (reason, index) => {
      const last = index == this.props.optOutReasons.length - 1
      const hasReason = this.props.referralOptOut.reasons && this.props.referralOptOut.reasons.includes(reason.value)
      const missing = this.props.referralOptOut.validationAttempted && !this.props.referralOptOut.validReasons

      let label = reason.label
      if (reason.value == 'other-side') {
        label = label + (this.props.referral.transaction_type == 'buy' ? ' Seller' : ' Buyer')
      } else {
        label = this.props.assignedCompany + ' ' + label
      }

      return <div key={reason.value} className={cx(reasonClasses, {last:last, selected:hasReason, missing:missing})} onClick={() => this.updateReasons(reason.value)}>
        <div className="ReferralOptOutDetails__check_icon"><i className="fa fa-check"/></div><div className="ReferralOptOutDetails__reason_label">{label}</div>
      </div>
    }

    const requiredFieldClassNames = (validProp) => {
      let classes = "ReferralOptOutDetails__text_wrapper"
      if (this.props.referralOptOut.validationAttempted && !validProp) {
        classes += " ReferralOptOutDetails__missing"
      }

      return classes
    }

    return (
      this.props.referral && this.props.referralOptOut ? <div className="ReferralOptOutDetails">
        {
          this.props.hasActiveAssignment ? <div className="ReferralOptOutDetails__header">
            <div className="ReferralOptOutDetails__header_title">Your client is choosing not to use...</div>
            <div className="ReferralOptOutDetails__other_title">Opcity Network {this.props.networkLabel}</div>
            <div className="ReferralOptOutDetails__company">{this.props.assignedCompany}</div>
            <div className="ReferralOptOutDetails__officer">{this.props.assignedOfficer}</div>
          </div> : null
        }
        <div className="ReferralOptOutDetails__body">
          <div className="ReferralOptOutDetails__body_title">Which {this.props.companyLabel.toLowerCase()} is your client using?</div>
          <div className="ReferralOptOutDetails__label">{this.props.companyLabel} Name <span className="ReferralOptOutDetails__required">Required</span></div>
          <div className={requiredFieldClassNames(this.props.referralOptOut.validCompany)}>
            <input type="text" value={this.props.referralOptOut.company} onChange={e => this.props.dispatch(updateCompany(e.target.value))}/>
          </div>
          <div className="ReferralOptOutDetails__label">{this.props.officerLabel} Officer Name</div>
          <div className="ReferralOptOutDetails__text_wrapper">
            <input type="text" value={this.props.referralOptOut.officer} onChange={e => this.props.dispatch(updateOfficer(e.target.value))}/>
          </div>
          <div className="ReferralOptOutDetails__refer" onClick={(e) => this.updateRefer()}>
            <input type="checkbox" className="ReferralOptOutDetails__check" checked={!!this.props.referralOptOut.refer} onChange={(e) => this.updateRefer(e)}/>
            <div className="ReferralOptOutDetails__check_label">Refer this {this.props.companyLabel.toLowerCase()} to the Opcity {this.props.networkLabel} Network</div>
          </div>
        </div>
        {
          this.props.referralOptOut.refer ? <div className="ReferralOptOutDetails__expand_section">
            <div className="ReferralOptOutDetails__label">Email <span className="ReferralOptOutDetails__required">Required</span></div>
            <div className={requiredFieldClassNames(this.props.referralOptOut.validEmail)}>
              <input type="text" value={this.props.referralOptOut.email} onChange={e => this.props.dispatch(updateEmail(e.target.value))}/>
            </div>
            <div className="ReferralOptOutDetails__label">Phone Number</div>
            <div className="ReferralOptOutDetails__text_wrapper">
              <input type="text" value={this.props.referralOptOut.phone} onChange={e => this.props.dispatch(updatePhone(e.target.value))}/>
            </div>
          </div> : null
        }
        {
          this.props.hasActiveAssignment ? <div className="ReferralOptOutDetails__reasons_feedback">
            <div className="ReferralOptOutDetails__reason_header">
              <div className="ReferralOptOutDetails__label">Reason <span className="ReferralOptOutDetails__required">Required</span></div>
              <a className="ReferralOptOutDetails__why" onClick={() => this.props.dispatch(showModal('ReferralOptOutModal', {initialState: {}}))}>Why do we ask this?</a>
            </div>
            <div className="ReferralOptOutDetails__instructions">Please choose the reason(s) why your client did not choose {this.props.assignedCompany} after their initial discussion.</div>
            { this.props.optOutReasons.map(renderReason) }
            <div className="ReferralOptOutDetails__label">Additional Feedback?</div>
            <div className="ReferralOptOutDetails__text_wrapper">
              <textarea type="text" value={this.props.referralOptOut.feedback} onChange={e => this.props.dispatch(updateFeedback(e.target.value))}/>
            </div>
          </div> : null
        }
        <div className="ReferralOptOutDetails__button_wrapper">
          <Button onClick={() => this.handleSubmit()} bsStyle="info">{this.props.buttonText}</Button>
        </div>
        <ReferralOptOutModal/>
        <RequiredFieldModal/>
      </div> : null
    )
  }
}

export default ReferralOptOutDetails
